import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../lib/queryKeys';
import { deleteLead } from '../api/leads';

/**
 * Delete a lead — removes detail cache, invalidates columns and stats.
 */
export function useDeleteLead () {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (leadId) => deleteLead(leadId),
    onSuccess: (_data, leadId) => {
      qc.removeQueries({ queryKey: queryKeys.leads.detail(leadId) });
      qc.invalidateQueries({ queryKey: ['leads', 'column'] });
      qc.invalidateQueries({ queryKey: queryKeys.leads.boardStats() });
    },
  });
}
